import React from 'react';
import { toast } from 'react-toastify';
import { Copy16Regular, Info16Regular } from '@fluentui/react-icons';
import styles from '../css/vdr.module.css';
import { StatusDot, StatusFilters, SearchField, normalizeStatus } from '../components/StatusUI';
import { Tooltip } from '@fluentui/react-components';

/** Project Mail. The mailbox is the project's inbound address. The list is saved project emails. */
const ProjectMailView = ({ mails = [], onSelect, selectedId, mailbox = '' }) => {
    const [query, setQuery] = React.useState('');
    const [statusFilter, setStatusFilter] = React.useState('all');

    const filtered = mails.filter(m => {
        const q = query.toLowerCase();
        if (q && !`${m.subject} ${m.senderName} ${m.senderEmail}`.toLowerCase().includes(q)) return false;
        if (statusFilter !== 'all' && normalizeStatus(m.status) !== statusFilter) return false;
        return true;
    });

    const copyMailbox = async () => {
        try {
            await navigator.clipboard.writeText(mailbox);
            toast.success('Mailbox copied');
        } catch {
            toast.info(mailbox);
        }
    };

    return (
        <>
            <div className={styles.contentHeader}>
                <div>
                    <h2 className={styles.contentTitle}>Project Mail</h2>
                    <p className={styles.contentDesc}>Project emails filed into Lens and available as project evidence.</p>
                </div>
                {mailbox ? (
                    <div className={styles.mailboxBox}>
                        {/* <Info16Regular title="Mailbox info" />  */}
                        {/* tooltip="Emails sent to this address are filed into Project Mail." */}
                        <Tooltip content="Emails sent to this address are filed into Project Mail.">
                            <Info16Regular title="Mailbox info" />
                        </Tooltip>
                        <span className={styles.mailboxBoxAddress}>{mailbox}</span>
                        <button type="button" className={styles.mailboxCopyBtn} onClick={copyMailbox}>
                            <Copy16Regular /> Copy
                        </button>
                    </div>
                ) : null}
            </div>
            <div className={styles.toolbar}>
                <SearchField value={query} onChange={setQuery} placeholder="Search mail" />
                <StatusFilters value={statusFilter} onChange={setStatusFilter} />
            </div>
            <div className={styles.table}>
                <div className={`${styles.tableHead} ${styles.mailCols}`}>
                    <span>Subject / Sender</span>
                    <span>Received</span>
                    <span>Attachments</span>
                    <span>Lens status</span>
                </div>
                {filtered.map(mail => {
                    const attachmentCount = mail.attachments?.length || 0;
                    return (
                        <div
                            key={mail.id}
                            className={`${styles.tableRow} ${styles.mailCols} ${selectedId === mail.id ? styles.tableRowSelected : ''}`}
                            onClick={() => onSelect?.(mail)}
                            role="button"
                            tabIndex={0}
                            onKeyDown={e => {
                                if (e.key === 'Enter' || e.key === ' ') onSelect?.(mail);
                            }}>
                            <div>
                                <div className={styles.mailSubject}>{mail.subject}</div>
                                <div className={styles.subMeta}>
                                    {mail.senderName} &lt;{mail.senderEmail}&gt;
                                </div>
                            </div>
                            <span className={styles.cellMuted}>{mail.received}</span>
                            <span className={styles.cellMuted}>
                                {attachmentCount} attachment{attachmentCount === 1 ? '' : 's'}
                            </span>
                            <StatusDot status={mail.status} />
                        </div>
                    );
                })}
                {filtered.length === 0 && <div className={styles.emptyState}>No mail matches</div>}
            </div>
        </>
    );
};

export default ProjectMailView;
